<script setup lang="ts">
import './assets/style.scss'
import { ref } from 'vue'

defineProps({
  label: {
    type: String,
    default: '',
  },
})

const model = defineModel<string>()
const open = ref(false)

const openHandler = async () => {
  open.value = true
}

const outsideHandler = () => {
  open.value = false
}
</script>

<template>
  <div class="v-colors-picker">
    <VTextField :label v-model="model" readonly>
      <template #append-inner>
        <div
          class="v-colors-picker__append"
          :style="{ backgroundColor: model }"
          @click.stop="openHandler"
        ></div>
      </template>
    </VTextField>

    <div v-if="open" class="v-colors-picker__windows" v-click-outside="outsideHandler">
      <VColorPicker v-model="model" :modes="['hexa']" />
    </div>
  </div>
</template>
